export function identity<Type>(arg: Type): Type {
  return arg;
}

export function noop(..._args: any[]) {} // NOSONAR

export const combineFilters =
  <Type>(...filters: ((elem: Type) => boolean)[]) =>
  (item: Type) =>
    filters.map((filter) => filter(item)).every((x) => x === true);
